module.exports = __webpack_public_path__ + "images/greenwheels75726ebcb5d5a00e8f449a244a4ad7f7.png";